var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-group',{attrs:{"label":_vm.$t('people.searchByName'),"description":_vm.$t('people.instructions.bulkSearch')}},[_c('c-text-area',{attrs:{"id":"bulk-search","value":_vm.bulkSearch},on:{"update:value":function($event){_vm.bulkSearch=$event}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }